import { brandConfig } from "../../../config/brand";
import type { TestProgress } from "../../../shared/types";

function formatMs(ms: number) {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function ProgressHeader({ progress, elapsedMs }: { progress: TestProgress; elapsedMs: number }) {
  const label = `Ερώτηση ${Math.min(progress.scoredIndex, 30)} / 30`;
  const percent = Math.min(100, Math.round((progress.answeredCount / progress.totalCount) * 100));

  return (
    <header className="sticky top-0 z-10 -mx-4 border-b border-white/10 bg-slate-950/78 px-4 py-3 backdrop-blur-xl sm:-mx-6 sm:px-6">
      <div className="mx-auto max-w-4xl">
        <div className="flex items-center justify-between gap-3 text-sm">
          <div className="min-w-0">
            <p className="truncate font-semibold text-white">{brandConfig.brandName}</p>
            <p className="text-xs text-slate-400">{label}</p>
          </div>
          <div className="rounded-full border border-cyan-200/20 bg-cyan-200/10 px-3 py-1 font-semibold text-cyan-100" aria-label="Συνολικός χρόνος">
            {formatMs(elapsedMs)}
          </div>
        </div>
        <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-white/10" aria-label={`Πρόοδος ${percent}%`}>
          <div className="h-full rounded-full bg-gradient-to-r from-cyan-300 via-blue-400 to-violet-400 transition-all" style={{ width: `${percent}%` }} />
        </div>
      </div>
    </header>
  );
}
